import React, { useCallback, useEffect, useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import Cookies from "js-cookie";
import Time from "../QuestionsList/Time";
import HowLoss from "../QuestionsList/HowLoss";
import Victim from "../QuestionsList/Victim";
import VictimName from "../QuestionsList/VictimName";
import VictimQualification from "../QuestionsList/VictimQualification";
import VictimAddress from "../QuestionsList/VictimAddress";
import Suspect from "../QuestionsList/Suspect";
import SuspectCall from "../QuestionsList/SuspectCall";
import SuspectSpeak from "../QuestionsList/SuspectSpeak";
import VictimBank from "../QuestionsList/VictimBank";
import SuspectBank from "../QuestionsList/SuspectBank";
import Support from "../QuestionsList/Support";
import HowMuch from "../QuestionsList/HowMuch";
import Profession from "../QuestionsList/Profession";
import PoliceStation from "../QuestionsList/PoliceStation";
import appVersion from "../../version";
import Header from "./Header";
import SuspectPlatform from "../QuestionsList/SuspectPlatform";
import BankUpload from "../QuestionsList/BankUpload";
import UploadNationalId from "../QuestionsList/UploadNationalId";
const apiKey = process.env.REACT_APP_AUTH_TOKEN;

const questionSequence = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
];

const ProgressBar = ({ current, total, question }) => {
  const progress = ((current + 1) / total) * 100;
  return (
    <div>
      <div className="bar-text">
        <div className="bar-line">
          <div
            style={{
              width: `${progress}%`,
              backgroundColor: "#007bff", // Blue color
              height: "3px",
              transition: "width 0.3s ease",
            }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <p>{question}</p>
          <p>&nbsp;/&nbsp;17</p>
        </div>
      </div>
    </div>
  );
};


const translations = {
  en: {
    victimDetails: "Victim Details",
    fraudsterDetails: "Fraudster Details",
    victimSubtext: "Enter the details of the victim",
  },
  Hi: {
    victimDetails: "पीड़ित का विवरण",
    fraudsterDetails: "धोखेबाज़ का विवरण",
    victimSubtext: "पीड़ित का विवरण दर्ज करें",
  },
  Kn: {
    victimDetails: "ವಂಚನೆಗೊಳಗಾದ ವ್ಯಕ್ತಿಯ ವಿವರಗಳು",
    fraudsterDetails: "ವಂಚಕರ ವಿವರಗಳು",
    victimSubtext: "ವಂಚನೆಗೊಳಗಾದ ವ್ಯಕ್ತಿಯ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
  },
};

const Questions = () => {
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [question, setQuestion] = useState(1);
  const [isNextDisabled, setIsNextDisabled] = useState(false);
  const [answerQuestion, setAnswerQuestion] = useState(Array(16).fill(false));
  const [language, setLanguage] = useState("en");
  const vist_id = Cookies.get("visitor_id");
  const botToken = Cookies.get("bot_token");
  const selectedLang = Cookies.get('selectedLanguage') || 'en';
  const app_ver = appVersion.app_ver;
  const [formData, setFormData] = useState({
    help: "",
    how_much: "",
    time: "",
    how_loss: "",
    national_file:"",
    victim_name: "",
    victim_age: "",
    victim_gender: "",
    victim_Profession: "",
    victim_qualification: "",
    victim_address: "",
    police_station: "",
    suspect_call: {"contactValues":[],"contactIds":[]},
    suspect_speak: {"contactValues":[],"contactIds":[]},
    suspect_contact: {"contactValues":[],"contactIds":[]},
    victim_bank: [{ id: 1, data: {} }],
    suspect_bank: [{ id: 1, data: {} }],
    support: "",
    address: {"address1":"","city":"","zip":""},
    supports: "",
    bank_file: [],
    phone_number:'',
    radio:"",
  });

  useEffect(() => {
    if (formData.time !== "") {
      const element = document.querySelector(`#question-2`);
      setCurrentQuestion(2);
      setQuestion(2);
      element.scrollIntoView({ behavior: "auto" });
    }
  }, [formData.time]);

  const addVictimBank = () => {
    setFormData((prevData) => ({
      ...prevData,
      victim_bank: [
        ...prevData.victim_bank,
        { id: prevData.victim_bank.length + 1, data: {} },
      ],
    }));
  };

  const addSuspectBank = () => {
    setFormData((prevData) => ({
      ...prevData,
      suspect_bank: [
        ...prevData.suspect_bank,
        { id: prevData.suspect_bank.length + 1, data: {} },
      ],
    }));
  };

  const questionCount = 19;

  const handleDataUpdate = (key, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
    const updatedAnswers = [...answerQuestion];
    updatedAnswers[currentQuestion] = false; // Mark as unanswered
    setAnswerQuestion(updatedAnswers);
  };

  const handleQuestionChange = (value) => {
    setQuestion(value - 1);
  };

  const handleNextPageClickQuestion = (value) => {
    const element = document.querySelector(`#question-suspect-bank-${value}`);

    element.scrollIntoView({ behavior: "smooth" });
  };

  const handleNextClickQuestion = (currentQuestion) => {
    const nextQuestion = Math.min(currentQuestion, questionCount - 1);
    const element = document.querySelector(`#question-${nextQuestion}`);

    setCurrentQuestion(nextQuestion);
    element.scrollIntoView({ behavior: "smooth" });
  };


  const policeStation = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      police_station: value,
    }));
    const updatedAnswers = [...answerQuestion];
    updatedAnswers[currentQuestion] = false; // Mark as unanswered
    setAnswerQuestion(updatedAnswers);
  };

  const Address = (value) => {

    setFormData((prevData) => ({
      ...prevData,
      address: value,
    }));
    const updatedAnswers = [...answerQuestion];
    updatedAnswers[currentQuestion] = false; // Mark as unanswered
    setAnswerQuestion(updatedAnswers);
  };

  const isQuestionAnswered = useCallback((questionIndex) => {
    switch (questionIndex) {
      case 0:
        return formData.help !== "";
      case 1:
        return formData.time !== "";
      case 2:
        return formData.how_much !== "";
      case 3:
        return true;
      case 4:
        return formData.bank_file[0] !== undefined;
      case 5:
        return true;
      case 6:
        return formData.national_file !== "" ;
      case 7:
        return (
          formData.victim_name !== "" &&
          formData.victim_age !== "" &&
          formData.victim_gender !== ""
        );
      case 8:
        return formData.victim_Profession !== "";
      case 9:
        return formData.victim_qualification !== "";
      case 10:
        return (
          formData.police_station.district !== undefined &&
          formData.police_station.policeStation !== undefined
        );
      case 11:
        return (
          formData.address.zip !== "" &&
          formData.address.city !== ""
        );
      case 12:
        return true;
      case 13:
        return formData.suspect_call.contactValues[0] !== undefined;
      case 14:
        return true;
      case 15:
        return formData.suspect_speak.contactValues[0] !== undefined;
        case 16:
          return (formData.radio === "no") ||( formData.radio === "yes" && formData.suspect_contact.contactValues[0] !== undefined);
      case 17:
        return formData.victim_bank.data !== "";
      case 18:
        return formData.supports !== "";
      // Add more cases as needed for other questions
      default:
        return true;
    }
  },[formData]);

  useEffect(() => {
    setIsNextDisabled(!isQuestionAnswered(currentQuestion - 1));
  }, [formData, currentQuestion,isQuestionAnswered]);

  // Scroll to a specific question element smoothly
  const scrollToQuestion = (questionIndex) => {
    const element = document.querySelector(`#question-${questionIndex}`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Move to the next question based on various conditions
  const handleNextQuestion = (optionId, result) => {  
      //  document.querySelectorAll('audio').forEach(audio => {
      //      audio.pause();
      //    audio.currentTime = 0;
      //   });
      window.dispatchEvent(new Event('pauseAllAudio'));
    if (isQuestionAnswered(currentQuestion)) {
      const updatedAnswers = [...answerQuestion];
      updatedAnswers[currentQuestion] = false; // Mark current question as answered
      setAnswerQuestion(updatedAnswers);
      setNextQuestion(currentQuestion + 1);
    } else {
      const updatedAnswers = [...answerQuestion];
      updatedAnswers[currentQuestion] = true; // Mark current question as unanswered
      setAnswerQuestion(updatedAnswers);
    }
  };

  // Move to the previous question
  const handlePreviousQuestion = () => {
    if (currentQuestion !== 2) {
      setPreviousQuestion(currentQuestion - 1);
      window.dispatchEvent(new Event('pauseAllAudio'));
    }
  };


  const setNextQuestion = (nextIndex) => {
    const nextQuestion = Math.min(nextIndex, questionCount - 1);
    setCurrentQuestion(nextQuestion);
    setQuestion(questionSequence[nextQuestion - 1]);
    scrollToQuestion(nextQuestion);
  };

  // Helper function to set the previous question with boundaries
  const setPreviousQuestion = (prevIndex) => {
    const prevQuestion = Math.max(prevIndex, 1);
    setCurrentQuestion(prevQuestion);
    setQuestion(questionSequence[prevQuestion - 1]);
    scrollToQuestion(prevQuestion);
  };

  const isHeaderVisible =
    (currentQuestion >= 6 && currentQuestion <= 11) ||
    (currentQuestion >= 13 && currentQuestion <= 17);
  const headerTitle = (() => {
    if (currentQuestion >= 6 && currentQuestion <= 11) {
      return translations[selectedLang].victimDetails;
    }
    if (currentQuestion >= 11 && currentQuestion <= 17)
      return translations[selectedLang].fraudsterDetails;
    return ""; // Default or empty title
  })();
  let currentQuestions
  if((currentQuestion>5)){
    currentQuestions = currentQuestion===6?"6A":currentQuestion === 7 ? "6B" :currentQuestion-1;
  }else{
    currentQuestions =currentQuestion
  }

      useEffect(() => {
        const cookieLang = Cookies.get("selectedLanguage") || "en";
        setLanguage(cookieLang);
      }, []);
  
      // Handler to update language state and cookie when user changes language
      const handleLanguageChange = (event) => {
        const newLanguage = event.target.value;
        setLanguage(newLanguage);
        Cookies.set("selectedLanguage", newLanguage, { expires: 365 });
      };

  return (
    <div style={{ height: "100vh", width: "100vw" }}>
      <Header />
      <div className="translate">
        <select value={language} onChange={handleLanguageChange}>
          <option value="en">English</option>
          <option value="Hi">हिंदी</option>
          <option value="Kn">ಕನ್ನಡ</option>
        </select>
        </div>
      <ProgressBar
        question={currentQuestions}
        current={currentQuestion}
        total={questionCount}
      />

      {isHeaderVisible && (
        <div className="victim-header"  >
          {headerTitle && (
            <h1 className="header" style={{ textAlign: "center" }}>
              {headerTitle}
            </h1>
          )}
          {headerTitle === translations[selectedLang].victimDetails && (
            <p style={{ textAlign: "center", marginTop: "-18px" }}>
              {translations[selectedLang].victimSubtext}
            </p>
          )}
        </div>
      )}
      <form>
        <div id="question-1" className="page">
          <Time
            onNext={handleNextClickQuestion}
            onTimeSelected={(value) => handleDataUpdate("time", value)}
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>

        <div id="question-2" className="page">
          <HowMuch
            onNext={handleNextClickQuestion}
            onHowMuchSelected={(value) => handleDataUpdate("how_much", value)}
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>
        <div
          id="question-3"
          className="page"
        >
          {/* {formData.victim_bank.map((item, index) => (
            <div
              key={item.id}
              id={`question-victim-bank-${index}`}
              className="page"
            > */}
              <VictimBank
                // index={index}
                onNext={handleNextClickQuestion}
                onVictimBankSelected={(value) =>
                  handleDataUpdate("victim_bank", value)
                }
                addVictimBank={addVictimBank}
                onQuestion={handleQuestionChange}
                answer={answerQuestion}
                apiKey={apiKey}
                botToken={botToken}
                vist_id={vist_id}
                app_ver={app_ver}
                selectedLang={selectedLang}
              />
            {/* </div>
          ))} */}
        </div>
        <div id="question-4" className="page">
          <BankUpload
            onNext={handleNextClickQuestion}
            submitSupport={(value) => handleDataUpdate("bank_file", value)}
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>
        <div id="question-5" className="page">
          <Victim
            onNext={handleNextClickQuestion}
            onQuestion={handleQuestionChange}
            selectedLang={selectedLang}
          />
        </div>
        <div id="question-6" className="page">
          <UploadNationalId
            onNext={handleNextClickQuestion}
            onNationalIdUploaded={(value) => handleDataUpdate("national_file", value)}
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>
        <div id="question-7" className="page" >
          <VictimName 
            onNext={handleNextClickQuestion}
            onVictimNameSelected={(value) =>
              handleDataUpdate("victim_name", value)
            }
            onVictimAgeSelected={(value) =>
              handleDataUpdate("victim_age", value)
            }
            onVictimGenderSelected={(value) =>
              handleDataUpdate("victim_gender", value)
            }
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>
        <div id="question-8" className="page">
          <Profession
            onNext={handleNextClickQuestion}
            onVictimProfessionSelected={(value) =>
              handleDataUpdate("victim_Profession", value)
            }
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>

        <div id="question-9" className="page">
          <VictimQualification
            onNext={handleNextClickQuestion}
            onVictimQualificationSelected={(value) =>
              handleDataUpdate("victim_qualification", value)
            }
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>

        <div id="question-10" className="page">
          <PoliceStation
            onNext={handleNextClickQuestion}
            onVictimAddressSelected={policeStation}
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>

        <div id="question-11" className="page">
          <VictimAddress
            onNext={handleNextClickQuestion}
            onVictimAddressSelected={Address}
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>
        <div id="question-12" className="page">
          <Suspect
            onNext={handleNextClickQuestion}
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>

        <div id="question-13" className="page">
          <SuspectCall
            onNext={handleNextClickQuestion}
            onSuspectCallSelected={(value) =>
              handleDataUpdate("suspect_call", value)
            }
            onPhoneNumber={(value) =>
              handleDataUpdate("phone_number", value)
            }
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>
        <div id="question-14" className="page">
          <Support
            onNext={handleNextClickQuestion}
            submitSupport={(value) => handleDataUpdate("supports", value)}
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>
        <div id="question-15" className="page">
          <SuspectSpeak
            onNext={handleNextClickQuestion}
            onSuspectSpeakSelected={(value) =>
              handleDataUpdate("suspect_speak", value)
            }
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>

        <div id="question-16" className="page">
          <SuspectPlatform
            onNext={handleNextClickQuestion}
            onSuspectContactSelected={(value) =>
              handleDataUpdate("suspect_contact", value)
            }
            onSuspectRadio={(value) =>
              handleDataUpdate("radio", value)
            }
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>
        <div
          id="question-17"
         className="page"
        >
              <SuspectBank
                onNext={handleNextClickQuestion}
                onSuspectBankSelected={(value) =>
                  handleDataUpdate("suspect_bank", value)
                }
                addSuspectBank={addSuspectBank}
                onQuestion={handleQuestionChange}
                onNextPage={handleNextPageClickQuestion}
                answer={answerQuestion}
                apiKey={apiKey}
                botToken={botToken}
                vist_id={vist_id}
                app_ver={app_ver}
                selectedLang={selectedLang}
              />
        </div>
        <div id="question-18" className="page">
          <HowLoss
            onNext={handleNextClickQuestion}
            onHowLossSelected={(value) => handleDataUpdate("how_loss", value)}
            onQuestion={handleQuestionChange}
            answer={answerQuestion}
            apiKey={apiKey}
            botToken={botToken}
            vist_id={vist_id}
            app_ver={app_ver}
            selectedLang={selectedLang}
          />
        </div>
        <div
          className="navigation-buttons"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            bottom: "0px",
            right: "0px",
            zIndex: "1000",
          }}
        >
          <div className="navigation-buttons">
            <button
              type="button"
              className="back-btn"
              onClick={handlePreviousQuestion}
              disabled={currentQuestion < 2}
            >
              <IoIosArrowUp />
            </button>
            <button
              type="button"
              className="next-btn"
              onClick={handleNextQuestion}
              disabled={
                currentQuestion === questionCount || // Disable if it's the last question
                isNextDisabled // Disable if the current question is not answered
              }
            >
              <IoIosArrowDown />
            </button>
          </div>
          {/* <p className="company-name">Power By Krishnas Digital</p> */}
        </div>
      </form>
    </div>
  );
};

export default Questions;
